import API from "Api";
import {
  GET_LOGIN_USER_ENDPOINT,
  GET_PHARMACY_CONFIG_ENDPOINT,
  FIRST_LOGIN_TOUR_ENDPOINT,
  REFRESHTOKEN,
} from "./endpoints";

export const getLoginUserAPI = () => {
  return API.get(GET_LOGIN_USER_ENDPOINT);
};

export const getPharmacyConfigAPI = (payload) => {
  return API.post(GET_PHARMACY_CONFIG_ENDPOINT, payload);
};
export const getRefreshTokenAPI = (payload) => {
  return API.get(REFRESHTOKEN, payload);
};

export const updateFirstLoginTourAPI = (payload) => {
  return API.post(FIRST_LOGIN_TOUR_ENDPOINT, payload);
};
